import { QUESTIONNAIRE_PAGE_BOX_SX } from '../../../../common';

// Form root: always flex column with gap + textAlign override
// (something up the tree inherits text-align: right; without this the
// fields shift right as soon as the FBoxContainer chrome is dropped).
export const GENERAL_INFORMATION_FORM_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  position: 'relative',
  textAlign: 'left',
  ...QUESTIONNAIRE_PAGE_BOX_SX,
};
